import type { ExpandPluginOptions } from '@atlaskit/editor-plugin-expand';

import type { FullPageEditorAppearance } from '../types';

interface Props {
	options: {
		editorAppearance: FullPageEditorAppearance;
		__livePage: boolean | undefined;
	};
}

export function expandPluginOptions({ options }: Props): ExpandPluginOptions {
	return {
		allowInsertion: true,
		useLongPressSelection: false,
		appearance: options.editorAppearance,
		allowInteractiveExpand: true,
		__livePage: options.__livePage,
	};
}
